import { api } from "@/lib/api";

/**
 * The request index.html already started, if it is the one we want.
 *
 * A script in the document head asks for the agency's record, and on a
 * property page for the listing too, before the bundle has finished
 * downloading. Both used to be made from inside a React effect, which put
 * them after the whole bundle had parsed and run: measured on the live
 * property page, 2,861ms between the HTML landing and the photograph that is
 * the largest paint being asked for.
 *
 * WHY IT MATCHES ON THE WHOLE URL
 * A BrandProvider given an explicit `slug` prop wants a different tenant
 * from the one the document asked about, and a property page reached by
 * client-side navigation is a different listing from the one in the HTML's
 * address. Neither may be handed the answer to somebody else's question, so
 * the path has to be the path that was asked for, not merely the same shape.
 *
 * Consumed once and then dropped, so a later refresh (after an agent saves
 * their branding, say) goes to the network exactly as it always did.
 *
 * Shaped like an axios response because that is what every caller unpacks,
 * and any failure at all falls through to the request the app would have
 * made on its own.
 */
export function takePreloaded(path, slot) {
  const pre = typeof window !== "undefined" ? window[slot] : null;
  // `alias` is the same question spelled the way the app asks it. The head
  // asks for a listing by domain, because it has one and does not yet know
  // the slug; the page asks by slug, because by then it does. One request,
  // either spelling.
  const asked = pre && ((pre.url && pre.url.endsWith(path))
                        || (pre.alias && pre.alias.endsWith(path)));
  if (asked) {
    window[slot] = null;
    return pre.promise.then((data) => (data ? { data } : api.get(path)));
  }
  return api.get(path);
}
